const adminIndexRouter = [
  {
    path: '/admin',
    name: 'AdminIndex',
    component: () => import('@/views/admin/index')
  },
  {
    path: '/admin/apply',
    name: 'AdminApply',
    component: () => import('@/views/admin/apply')
  },
  {
    path: '/admin/list',
    name: 'AdminList',
    component: () => import('@/views/admin/admin_list')
  },
  {
    path: '/admin/log',
    name: 'AdminLog',
    component: () => import('@/views/admin/admin_log')
  },
  {
    path: '/admin/visit',
    name: 'AdminVisit',
    component: () => import('@/views/admin/visit')
  },
  {
    path: '/admin/statistics/flow',
    name: 'AdminStatisticsFlow',
    component: () => import('@/views/admin/statistics/flow')
  },
  {
    path: '/admin/statistics/client',
    name: 'AdminStatisticsClient',
    component: () => import('@/views/admin/statistics/client')
  },
  {
    path: '/admin/statistics/client_ref',
    name: 'AdminStatisticsClientRef',
    component: () => import('@/views/admin/statistics/client_ref')
  },
  {
    path: '/admin/statistics/sign',
    name: 'AdminStatisticsSign',
    component: () => import('@/views/admin/statistics/sign')
  },
  {
    path: '/admin/order/index',
    name: 'AdminOrderIndex',
    component: () => import('@/views/admin/order/index')
  },
  {
    path: '/admin/order/stat',
    name: 'AdminOrderStat',
    component: () => import('@/views/admin/order/stat')
  },
  {
    path: '/admin/setting',
    name: 'AdminSetting',
    component: () => import('@/views/admin/setting')
  },
  {
    path: '/admin/debug',
    name: 'AdminDebug',
    component: () => import('@/views/admin/debug')
  },
  {
    path: '/admin/tag',
    name: 'AdminTagIndex',
    component: () => import('@/views/admin/tag/index')
  }
]

export default adminIndexRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/index.js